import { makeStyles, tokens } from '@fluentui/react-components';
export var useAiHubHeaderStyles = makeStyles({
    container: {
        alignItems: 'center',
        backgroundColor: tokens.colorNeutralBackground4,
        boxSizing: 'border-box',
        display: 'flex',
        height: '48px',
        justifyContent: 'space-between',
        position: 'sticky',
        textAlign: 'left',
        width: '100%',
    },
    toggleContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        alignItems: 'flex-end',
        justifyContent: 'center',
    },
});
//# sourceMappingURL=AiHubHeader.styles.js.map